import { useState } from 'react';

import { TabScreenWrapper } from '@components/General/TabScreen';
import { Flap } from '@models/Flap';
import { Organization } from '@models/Organization';
import { AltaComunicacionesGeneral } from '@components/Comunicaciones/AltaComunicacionGeneral';

interface ComunicacionesScreenProps {
    org: Organization;
}

const ComunicacionesScreen = ({org}: ComunicacionesScreenProps) => {

    const [clickedScreen, setClickedScreen] = useState<string>('comunicaciones_generales')

    const flaps: Flap[] = [
        { 
            id: 'comunicaciones_generales', 
            label: 'Cartelera', 
            content: <AltaComunicacionesGeneral orgID={org.id} timezone={org.timezone}/> 
        },
    ];

    return (
        <TabScreenWrapper
            title="Comunicacion"
            subtitle="Envio de mensajes a todos los colaboradores"
            flaps={flaps}
            flag={org.newFlags.DashboardNotification}
            clickedScreen={clickedScreen}
            setClickedScreen={setClickedScreen}
        />
    );
};

export default ComunicacionesScreen